<template>
  <app-sessions-list />
</template>

<script>
import AppSessionsList from '@/components/AppSessionsList'

export default {
  components: {
    AppSessionsList
  }
}
</script>
